import axios from 'axios';
import { type HttpServiceConfigurator } from './http-service-configurator';

declare global {
  interface Window {
    activeHttpCount: number;
  }
}

window.activeHttpCount = 0;

const incrementHttpCounter = () => {
  window.activeHttpCount++;
};

const decrementHttpCounter = () => {
  window.activeHttpCount--;
};

export const createHttpService = (
  httpServiceConfigurator: HttpServiceConfigurator
) => {
  const httpServiceInstance = axios.create(
    httpServiceConfigurator.getHttpClientConfig()
  );

  httpServiceInstance.interceptors.request.use(
    async (config) => {
      
      incrementHttpCounter();
      return await httpServiceConfigurator.prepareRequestConfig(config);
    }
  );

  httpServiceInstance.interceptors.response.use(
    (response) => {
      decrementHttpCounter();
      return httpServiceConfigurator.prepareHttpSuccessResponse(response);
    },
    (error) => {
      decrementHttpCounter();
      return httpServiceConfigurator.prepareHttpErrorResponse(error);
    }
  );

  return httpServiceConfigurator.createInterface(httpServiceInstance);
};
